
const list = [{
  name: '酒店管理',
  menuItem: {
    name: '酒店管理',
    iconClass: 'icon-hotel-manage',
    route: '/brand-manage'
  }
}, {
  name: '品牌管理',
  menuItem: {
    name: '品牌管理',
    route: '/brand-manage'
  }
}, {
  name: '酒店列表',
  menuItem: {
    name: '酒店列表',
    route: '/hotel-list'
  }
}, {
  name: '权限管理',
  menuItem: {
    name: '权限管理',
    iconClass: 'icon-auth-manage',
    route: '/admin-list'
  }
}, {
  name: '管理员列表',
  menuItem: {
    name: '管理员列表',
    route: '/admin-list'
  }
}, {
  name: '身份管理',
  menuItem: {
    name: '身份管理',
    route: '/role-manage'
  }
}];
const mapper = new Map();
list.forEach(value => {
  mapper.set(value.name, value.menuItem);
});

export default mapper;